import { $enum } from 'ts-enum-util'
import { IDateTypes, IEquipmentTypes, IRateTypes } from './types'

export const DEFAULT_RADIUS = 50

export const REQUIRED_MESSAGE = 'This field is required'
export const DAYS_OF_WEEK_MESSAGE = 'Days of the week selection required'

export const DATE_OPTION_VALUES = $enum(IDateTypes).getValues()
export const EQUIPMENT_OPTION_VALUES = $enum(IEquipmentTypes).getValues()
export const RATE_TYPE_OPTION_VALUES = $enum(IRateTypes).getValues()

export const TEST_IDS = {
  cancelButton: 'saved-lane-cancel',
  carrierApplicationTitle: 'saved-lane-carrier-title',
  datePicker: 'saved-lane-date-field',
  dateTypeSelect: 'saved-lane-date-type-field',
  dayOfWeekSingleSelect: 'saved-lane-day',
  daysOfWeekFormSection: 'saved-lane-days-of-week-section',
  dropoffInput: 'dropoff-autocomplete',
  dropoffRadius: 'dropoff-radius',
  equipmentSelect: 'saved-lane-equipment-field',
  motorCarrierFormSection: 'saved-lane-carrier-application-section',
  motorCarrierIdSelect: 'saved-lane-carrier-application-id-field',
  pickupInput: 'pickup-autocomplete',
  pickupRadius: 'pickup-radius',
  rateInput: 'saved-lane-rate-field',
  rateTypeSelect: 'saved-lane-rate-type-field',
  notificationsSwitch: 'saved-lane-notifications-switch',
  recipientAutocomplete: 'recipient-autocomplete',
  recipientsFormSection: 'saved-lane-recipients-section',
  recipientRow: 'saved-lane-recipient-row',
  recipientName: 'saved-lane-recipient-row-name',
  recipientNotificationSwitch: 'saved-lane-recipient-row-notification-switch',
  recipientDeleteButton: 'saved-lane-recipient-row-button',
  specificDateFormSection: 'saved-lane-specific-date-section',
  submitButton: 'saved-lane-submit',
}
